import { render } from "./AddProductToCart.vue?vue&type=template&id=04dfba69"
import script from "./AddProductToCart.vue?vue&type=script&lang=js"
export * from "./AddProductToCart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__